<template>
  <el-dialog
    width="96%"
    top="2vh"
    :model-value="visible"
    :before-close="cerrar"
    destroy-on-close
    class="imposicion-dialog"
    :show-close="false"
  >
    <div class="custom-header">
      <div class="brand">
        <div class="title">
          <b>Desarrollo de Imposición</b>
        </div>
      </div>
      <div class="top-actions">
        <el-button @click="cerrar">Cancelar</el-button>
        <el-button
          type="primary"
          plain
          :loading="store.isLoading"
          @click="recalcular"
        >
          Recalcular opciones
        </el-button>
        <el-button
          type="success"
          :disabled="!store.opcionActiva"
          @click="confirmar"
        >
          Aplicar selección → Pisar cotización
        </el-button>
      </div>
    </div>

    <div
      v-loading="store.isLoading"
      :class="['layout-grid', { 'is-expanded': isTableExpanded }]"
    >
      <div class="left-col">
        <el-card
          shadow="never"
          class="full-h-card"
        >
          <div
            v-loading="isLoadingFiltros"
            class="filters-row"
            style="grid-template-columns: repeat(5, 1fr)"
          >
            <div class="filter-field">
              <label>Categoría material</label>
              <el-select
                v-model="parametrosLocal.codigoCategoriaMaterial"
                placeholder="(todas)"
                clearable
                size="small"
                filterable
                @change="handleCategoriaChange"
              >
                <el-option
                  v-for="cat in categoriasDisponibles"
                  :key="cat.Codigo"
                  :label="cat.Descripcion"
                  :value="cat.Codigo"
                />
              </el-select>
            </div>

            <div class="filter-field">
              <label>Familia material</label>
              <el-autocomplete
                v-model="familiaDescripcionTexto"
                size="small"
                :value-key="'Descripcion'"
                :fetch-suggestions="handleFamiliaSearch"
                clearable
                placeholder="Buscar familia..."
                style="width: 100%"
                @select="handleFamiliaSelect"
                @clear="handleFamiliaClear"
              />
            </div>

            <div class="filter-field">
              <label>Tipo material</label>
              <el-select
                v-model="parametrosLocal.codigoMaterialTipo"
                placeholder="(todos)"
                clearable
                size="small"
                filterable
                @change="recalcular"
              >
                <el-option
                  v-for="tipo in tiposFiltrados"
                  :key="tipo.Codigo"
                  :label="tipo.Descripcion"
                  :value="tipo.Codigo"
                />
              </el-select>
            </div>

            <div class="filter-field">
              <label>Genérico</label>
              <el-select
                v-model="parametrosLocal.filtroGenerico"
                size="small"
                @change="recalcular"
              >
                <el-option
                  v-for="opt in MaterialGenericoFiltroOptions"
                  :key="opt.Codigo"
                  :label="opt.Descripcion"
                  :value="opt.Codigo"
                />
              </el-select>
            </div>

            <div class="filter-field">
              <label>Filtro tabla</label>
              <el-input
                v-model="filtros.texto"
                placeholder="Ej: BOPP, PP..."
                clearable
                size="small"
              />
            </div>
          </div>

          <div
            v-if="mostrarAlertaAnchoCero"
            style="
              margin-bottom: 12px;
              padding: 10px 14px;
              background: #fef3c7;
              border: 1px solid #f59e0b;
              border-radius: 8px;
              display: flex;
              align-items: center;
              gap: 8px;
            "
          >
            <span style="color: #92400e; font-size: 13px">
              Por favor, configure el Ancho máximo del Recurso
              <b>{{ maquinaSeleccionadaObj?.Descripcion }}</b>
            </span>
          </div>

          <div
            class="state-row"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 12px;
            "
          >
            <div style="display: flex; gap: 10px">
              <el-tag
                size="small"
                type="info"
                effect="plain"
                >Orden actual: <b>{{ ordenActualTexto }}</b></el-tag
              >
              <el-tag
                size="small"
                type="info"
                effect="plain"
                >Opciones: <b>{{ opcionesFiltradas.length }}</b></el-tag
              >
              <el-tag
                v-if="false"
                size="small"
                :type="estadoPostRedondeo === 'ok' ? 'success' : 'danger'"
                effect="plain"
              >
                Post-redondeo: <b>{{ estadoPostRedondeo }}</b>
              </el-tag>
            </div>

            <el-button
              size="small"
              :type="isTableExpanded ? 'primary' : 'default'"
              plain
              @click="toggleTableExpand"
            >
              {{ isTableExpanded ? '◩ Contraer vista' : '▤ Expandir tabla' }}
            </el-button>
          </div>
          <div class="table-wrapper">
            <el-table
              :key="tableKey"
              ref="tableRef"
              :data="opcionesPaginadas"
              height="100%"
              highlight-current-row
              size="small"
              stripe
              border
              row-key="id"
              @current-change="handleFilaSeleccionada"
              @sort-change="handleSortChange"
            >
              <el-table-column
                v-for="col in columnas"
                :key="col.prop"
                :prop="
                  col.prop === 'anchoMinimo'
                    ? 'anchoImpresion'
                    : col.prop === 'kg'
                      ? undefined
                      : col.prop
                "
                :label="col.label.replace('{u}', unidadTexto)"
                :width="col.width"
                :min-width="col.minWidth"
                :align="col.align"
                :sortable="col.sortable"
                :show-overflow-tooltip="col.tooltip"
              >
                <template #default="{ row }">
                  <span v-if="col.prop === 'nombreMaquina'"
                    ><b>{{ row.nombreMaquina || '—' }}</b></span
                  >

                  <span v-else-if="col.prop === 'descripcionMaterial'">{{
                    row.descripcionMaterial
                  }}</span>

                  <span v-else-if="col.prop === 'familiaMaterial'">{{ row.familiaMaterial }}</span>

                  <span v-else-if="col.prop === 'precioMaterial'">{{
                    row.precioMaterial.toFixed(2)
                  }}</span>

                  <span v-else-if="col.prop === 'medidaAnchoUsada'">
                    <b
                      :style="{
                        color:
                          Math.abs(row.medidaAnchoUsada - parametrosLocal.medidaAncho) > 0.01
                            ? '#d97706'
                            : 'inherit',
                      }"
                    >
                      {{ formatDecimal(row.medidaAnchoUsada) }}
                    </b>
                  </span>
                  <span v-else-if="col.prop === 'medidaDesarrolloUsada'">
                    <b
                      :style="{
                        color:
                          Math.abs(row.medidaDesarrolloUsada - parametrosLocal.medidaDesarrollo) >
                          0.01
                            ? '#d97706'
                            : 'inherit',
                      }"
                    >
                      {{ formatDecimal(row.medidaDesarrolloUsada) }}
                    </b>
                  </span>

                  <span
                    v-else-if="col.prop === 'visualizacion.gapAncho'"
                    style="color: #64748b"
                  >
                    {{ Number(row.visualizacion.gapAncho || 0).toFixed(3) }}
                  </span>

                  <span
                    v-else-if="col.prop === 'visualizacion.gapDesarrollo'"
                    style="color: #64748b"
                  >
                    {{ Number(row.visualizacion.gapDesarrollo || 0).toFixed(3) }}
                  </span>

                  <span v-else-if="col.prop === 'anchoImpresion'">{{
                    formatDecimal(row.anchoImpresion)
                  }}</span>

                  <span v-else-if="col.prop === 'anchoMinimo'">{{
                    formatDecimal(row.anchoImpresion)
                  }}</span>

                  <span v-else-if="col.prop === 'anchoRedondeado'"
                    ><b>{{ formatDecimal(row.anchoRedondeado) }}</b></span
                  >

                  <span v-else-if="col.prop === 'anchoBobinaMadre'">
                    <span v-if="row.anchoBobinaMadre">{{
                      formatDecimal(row.anchoBobinaMadre)
                    }}</span>
                    <span
                      v-else
                      style="color: #a8abb2"
                      >—</span
                    >
                  </span>

                  <span v-else-if="col.prop === 'cilindro'">
                    <template v-if="parametrosLocal.unidadPreferencia === 'in'">
                      {{ (row.cilindro * 25.4).toFixed(2) }} mm ({{ row.cilindro.toFixed(3) }} in)
                    </template>
                    <template v-else>
                      {{ row.cilindro.toFixed(2) }} mm ({{ (row.cilindro / 25.4).toFixed(3) }} in)
                    </template>
                  </span>

                  <span v-else-if="col.prop === 'engranaje'"
                    ><b>{{ row.engranaje || '—' }}</b></span
                  >

                  <span v-else-if="col.prop === 'cantidadCilindros'">
                    <span v-if="row.cantidadCilindros > 0">{{ row.cantidadCilindros }}</span>
                    <span
                      v-else
                      class="text-gray-400"
                      >—</span
                    >
                  </span>

                  <span v-else-if="col.prop === 'cantidadMagneticos'">
                    <span v-if="row.cantidadMagneticos > 0">{{ row.cantidadMagneticos }}</span>
                    <span
                      v-else
                      class="text-gray-400"
                      >—</span
                    >
                  </span>

                  <span v-else-if="col.prop === 'cantidadAlmasStamping'">
                    <span v-if="row.cantidadAlmasStamping > 0">{{
                      row.cantidadAlmasStamping
                    }}</span>
                    <span
                      v-else
                      class="text-gray-400"
                      >—</span
                    >
                  </span>

                  <span v-else-if="col.prop === 'cantidadCilindrosRelieveEnLinea'">
                    <span v-if="row.cantidadCilindrosRelieveEnLinea > 0">{{
                      row.cantidadCilindrosRelieveEnLinea
                    }}</span>
                    <span
                      v-else
                      class="text-gray-400"
                      >—</span
                    >
                  </span>

                  <span v-else-if="col.prop === 'metrosLinealesRequeridos'">{{
                    row.metrosLinealesRequeridos.toFixed(1)
                  }}</span>

                  <span v-else-if="col.prop === 'metrosCuadrados'">{{
                    row.metrosCuadrados.toFixed(2)
                  }}</span>

                  <span v-else-if="col.prop === 'kg'">—</span>

                  <span
                    v-else-if="col.prop === 'aprovechamientoPorcentaje'"
                    :style="{
                      color:
                        row.aprovechamientoPorcentaje >= 90
                          ? '#10b981'
                          : row.aprovechamientoPorcentaje >= 70
                            ? '#f59e0b'
                            : '#ef4444',
                      fontWeight: 'bold',
                    }"
                  >
                    {{ row.aprovechamientoPorcentaje.toFixed(1) }}%
                  </span>

                  <span v-else-if="col.prop === 'score'"
                    ><b>{{ row.score.toFixed(1) }}</b></span
                  >

                  <span v-else-if="col.prop === 'observaciones'">
                    <span
                      v-if="row.observaciones.length"
                      style="color: #d97706; font-size: 11px"
                      >{{ row.observaciones.join(', ') }}</span
                    >
                    <span
                      v-else
                      class="muted"
                      >—</span
                    >
                  </span>

                  <span v-else>{{ row[col.prop] }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-bar">
            <el-pagination
              v-model:current-page="paginaActual"
              :page-size="filasPorPagina"
              :total="opcionesFiltradas.length"
              layout="total, prev, pager, next"
              small
              background
            />
          </div>
        </el-card>
      </div>

      <div class="right-col">
        <el-card
          shadow="never"
          class="params-card"
          style="margin-bottom: 15px"
        >
          <div class="params-grid">
            <div class="param-item">
              <label
                >{{ labelMedidaEje }} (A) <small>{{ unidadTexto }}</small></label
              >
              <el-input-number
                ref="inputRef"
                v-model="parametrosLocal.medidaAncho"
                :controls="false"
                :formatter="formatter"
                :parser="parser"
                size="small"
                class="w-100"
                @focus="handleFocus"
                @blur="handleBlur(parametrosLocal.medidaAncho)"
                @change="recalcular"
              />
            </div>
            <div class="param-item">
              <label
                >{{ labelMedidaDesarrollo }} (D) <small>{{ unidadTexto }}</small></label
              >
              <el-input-number
                ref="inputRef"
                v-model="parametrosLocal.medidaDesarrollo"
                :controls="false"
                :formatter="formatter"
                :parser="parser"
                size="small"
                class="w-100"
                @focus="handleFocus"
                @blur="handleBlur(parametrosLocal.medidaDesarrollo)"
                @change="recalcular"
              />
            </div>
            <div class="param-item">
              <label
                >{{ labelLaterales }} <small>{{ unidadTexto }}</small></label
              >
              <el-input-number
                ref="inputRef"
                v-model="parametrosLocal.laterales"
                :controls="false"
                :formatter="formatter"
                :parser="parser"
                size="small"
                class="w-100"
                @focus="handleFocus"
                @blur="handleBlur(parametrosLocal.laterales)"
                @change="recalcular"
              />
            </div>
            <div class="param-item">
              <label>
                <span
                  >{{ labelGapEje }} <small>{{ unidadTexto }}</small></span
                >
                <el-switch
                  v-model="habilitarGapAncho"
                  size="small"
                  title="Habilitar/Deshabilitar"
                  @change="handleToggleGapAncho"
                />
              </label>
              <el-input-number
                ref="inputRef"
                v-model="parametrosLocal.gapAncho"
                :disabled="!habilitarGapAncho"
                :controls="false"
                :formatter="formatter"
                :parser="parser"
                size="small"
                class="w-100"
                @focus="handleFocus"
                @blur="handleBlur(parametrosLocal.gapAncho)"
                @change="recalcular"
              />
            </div>

            <div class="param-item">
              <label>
                <span
                  >{{ labelGapDesarrollo }} <small>{{ unidadTexto }}</small></span
                >
                <el-switch
                  v-model="habilitarGapDesarrollo"
                  size="small"
                  title="Habilitar/Deshabilitar"
                  @change="handleToggleGapDesarrollo"
                />
              </label>
              <el-input-number
                ref="inputRef"
                v-model="parametrosLocal.gapDesarrollo"
                :disabled="!habilitarGapDesarrollo"
                :controls="false"
                :formatter="formatter"
                :parser="parser"
                size="small"
                class="w-100"
                @focus="handleFocus"
                @blur="handleBlur(parametrosLocal.gapDesarrollo)"
                @change="recalcular"
              />
            </div>
            <div class="param-item">
              <label
                >Máquina: ancho máx. <small>{{ unidadTexto }}</small></label
              >
              <el-input-number
                v-if="anchoMaximoMaquinaActual !== null"
                ref="inputRef"
                :model-value="anchoMaximoMaquinaActual"
                disabled
                :controls="false"
                :formatter="formatter"
                :parser="parser"
                size="small"
                class="w-100"
                @focus="handleFocus"
                @blur="handleBlur(anchoMaximoMaquinaActual)"
              />
              <el-input
                v-else
                model-value="—"
                disabled
                size="small"
                class="w-100"
              />
            </div>
            <div
              v-if="false"
              class="param-item"
            >
              <label>Forma</label>
              <el-select
                v-model="parametrosLocal.formaTroquel"
                placeholder="Seleccionar"
                clearable
                size="small"
                class="w-100"
                @change="recalcular"
              >
                <el-option
                  v-for="forma in formaList"
                  :key="forma.Codigo"
                  :label="forma.Descripcion"
                  :value="forma.Codigo"
                />
              </el-select>
            </div>

            <div class="param-item">
              <label>
                <span>{{ labelEtiquetasEje }} <small>(Eje)</small></span>
                <el-switch
                  v-model="habilitarEtiquetasEje"
                  size="small"
                  title="Habilitar/Deshabilitar"
                  @change="handleToggleEtiquetasEje"
                />
              </label>
              <el-input-number
                ref="inputRef"
                v-model="parametrosLocal.etiquetasEje"
                :disabled="!habilitarEtiquetasEje"
                :min="1"
                :controls="false"
                :formatter="formatter"
                :parser="parser"
                size="small"
                class="w-100"
                @focus="handleFocus"
                @blur="handleBlur(parametrosLocal.etiquetasEje)"
                @change="recalcular"
              />
            </div>

            <div class="param-item">
              <label>
                <span>{{ labelEtiquetasDesarrollo }}</span>
                <el-switch
                  v-model="habilitarEtiquetasDesarrollo"
                  size="small"
                  title="Habilitar/Deshabilitar"
                  @change="handleToggleEtiquetasDesarrollo"
                />
              </label>
              <el-input-number
                ref="inputRef"
                v-model="parametrosLocal.etiquetasDesarrollo"
                :disabled="!habilitarEtiquetasDesarrollo"
                :min="1"
                :controls="false"
                :formatter="formatter"
                :parser="parser"
                size="small"
                class="w-100"
                @focus="handleFocus"
                @blur="handleBlur(parametrosLocal.etiquetasDesarrollo)"
                @change="recalcular"
              />
            </div>

            <div class="param-item">
              <label style="color: #0f172a"
                >Ancho Mín. Calculado <small>{{ unidadTexto }}</small></label
              >
              <el-input-number
                ref="inputRef"
                :model-value="anchoMinimoCalculado"
                disabled
                :controls="false"
                :formatter="formatter"
                :parser="parser"
                size="small"
                class="w-100"
                @focus="handleFocus"
                @blur="handleBlur(anchoMinimoCalculado)"
              />
            </div>
            <div class="param-item">
              <label
                >Cilindro (desarrollo) <small>{{ unidadTexto }}</small></label
              >
              <el-select
                v-model="filtros.cilindro"
                placeholder="(todos)"
                clearable
                size="small"
                class="w-100"
              >
                <el-option
                  v-for="cil in cilindrosDisponibles"
                  :key="cil"
                  :label="formatMedida(cil)"
                  :value="cil"
                />
              </el-select>
            </div>
            <div class="param-item">
              <label>Máquina</label>
              <el-select
                v-model="maquinaSeleccionada"
                size="small"
                filterable
                class="w-100"
                @change="handleMaquinaChange"
              >
                <el-option
                  v-for="m in maquinaOpciones"
                  :key="m.Codigo"
                  :label="m.Descripcion"
                  :value="m.Codigo"
                />
              </el-select>
            </div>
            <div
              class="param-item"
              style="display: flex; align-items: flex-end"
            >
              <el-button
                type="primary"
                size="small"
                class="w-100"
                @click="resetearFiltrosImposicion"
              >
                <IconRestore></IconRestore> Resetear filtros
              </el-button>
            </div>
            <div
              style="grid-column: span 3; display: grid; grid-template-columns: 1fr 1fr; gap: 12px"
            >
              <div class="param-item">
                <label>Política redondeo <small>material</small></label>
                <el-select
                  v-model="parametrosLocal.criterioRedondeo"
                  size="small"
                  class="w-100"
                  @change="recalcular"
                >
                  <el-option
                    label="Sin definir"
                    value="sin_definir"
                  />
                  <el-option
                    label="Solo ancho exacto"
                    value="exacto"
                  />
                  <el-option
                    label="Redondear a bobina"
                    value="bobina_entera"
                  />
                </el-select>
              </div>

              <div
                v-if="false"
                class="param-item"
              >
                <label>Tipo de Troquel</label>
                <el-select
                  v-model="parametrosLocal.codigoSuajeTipo"
                  size="small"
                  class="w-100"
                  @change="recalcular"
                >
                  <el-option
                    label="Ninguno"
                    value="ninguno"
                  />
                  <el-option
                    label="Todos los tipos"
                    value="todos"
                  />
                  <el-option
                    v-for="tipo in swageStore.claseSuaje"
                    :key="tipo.Codigo"
                    :label="tipo.Descripcion"
                    :value="tipo.Codigo"
                  />
                </el-select>
              </div>
            </div>
          </div>

          <div style="display: flex; gap: 12px; margin-top: 10px">
            <div
              v-if="false"
              class="toggle-row"
              style="flex: 1"
              @click="toggleRotar"
            >
              <el-switch
                v-model="parametrosLocal.permitirRotacion"
                @change="recalcular"
              />
              <div class="txt">
                <b>Permitir rotación del producto</b>
                <span>Intercambia A ↔ D para generar combinaciones</span>
              </div>
            </div>

            <el-popover
              placement="bottom"
              title="Tolerancia de dimensiones del producto"
              :width="400"
              trigger="click"
            >
              <template #reference>
                <div
                  class="toggle-row"
                  style="
                    flex: 1;
                    justify-content: center;
                    border-color: #3b82f6;
                    background: #eff6ff;
                  "
                >
                  <div
                    class="txt"
                    style="text-align: center"
                  >
                    <b style="color: #1e40af">⚙️ Configurar Tolerancias</b>
                    <span style="color: #3b82f6">Define márgenes para reciclaje de troqueles</span>
                  </div>
                </div>
              </template>

              <div
                style="
                  display: grid;
                  grid-template-columns: 2fr 1fr 1fr;
                  gap: 10px;
                  align-items: center;
                "
              >
                <div></div>
                <div style="text-align: center; color: #475569"><b>( - )</b></div>
                <div style="text-align: center; color: #475569"><b>( + )</b></div>

                <div style="font-size: 12px; color: #334155">
                  Tol. {{ labelMedidaEje }} <small>({{ unidadTexto }})</small>
                </div>
                <div>
                  <el-input-number
                    ref="inputRef"
                    v-model="parametrosLocal.tolMedidaAnchoMin"
                    :controls="false"
                    :formatter="formatter"
                    :parser="parser"
                    size="small"
                    class="w-100"
                    placeholder="Ej: -3"
                    @focus="handleFocus"
                    @blur="handleBlur(parametrosLocal.tolMedidaAnchoMin)"
                    @change="recalcular"
                  />
                </div>
                <div>
                  <el-input-number
                    ref="inputRef"
                    v-model="parametrosLocal.tolMedidaAnchoMax"
                    :controls="false"
                    :formatter="formatter"
                    :parser="parser"
                    size="small"
                    class="w-100"
                    placeholder="Ej: 5"
                    @focus="handleFocus"
                    @blur="handleBlur(parametrosLocal.tolMedidaAnchoMax)"
                    @change="recalcular"
                  />
                </div>

                <div style="font-size: 12px; color: #334155">
                  Tol. {{ labelMedidaDesarrollo }} <small>({{ unidadTexto }})</small>
                </div>
                <div>
                  <el-input-number
                    ref="inputRef"
                    v-model="parametrosLocal.tolMedidaDesarrolloMin"
                    :controls="false"
                    :formatter="formatter"
                    :parser="parser"
                    size="small"
                    class="w-100"
                    @focus="handleFocus"
                    @blur="handleBlur(parametrosLocal.tolMedidaDesarrolloMin)"
                    @change="recalcular"
                  />
                </div>
                <div>
                  <el-input-number
                    ref="inputRef"
                    v-model="parametrosLocal.tolMedidaDesarrolloMax"
                    :controls="false"
                    :formatter="formatter"
                    :parser="parser"
                    size="small"
                    class="w-100"
                    @focus="handleFocus"
                    @blur="handleBlur(parametrosLocal.tolMedidaDesarrolloMax)"
                    @change="recalcular"
                  />
                </div>

                <div
                  style="
                    border-top: 1px solid #e2e8f0;
                    padding-top: 10px;
                    margin-top: 5px;
                    grid-column: span 3;
                  "
                >
                  <b style="font-size: 12px; color: #0f172a"
                    >GAPs (Rango absoluto si no definió gaps / Relativo si los definió)</b
                  >
                </div>

                <div></div>
                <div style="text-align: center; color: #475569"><b>( - )</b></div>
                <div style="text-align: center; color: #475569"><b>( + )</b></div>

                <div style="font-size: 12px; color: #334155">
                  {{ labelGapEje }} <small>({{ unidadTexto }})</small>
                </div>
                <div>
                  <el-input-number
                    ref="inputRef"
                    v-model="parametrosLocal.tolGapAnchoMin"
                    :controls="false"
                    :formatter="formatter"
                    :parser="parser"
                    size="small"
                    class="w-100"
                    @focus="handleFocus"
                    @blur="handleBlur(parametrosLocal.tolGapAnchoMin)"
                    @change="recalcular"
                  />
                </div>
                <div>
                  <el-input-number
                    ref="inputRef"
                    v-model="parametrosLocal.tolGapAnchoMax"
                    :controls="false"
                    :formatter="formatter"
                    :parser="parser"
                    size="small"
                    class="w-100"
                    @focus="handleFocus"
                    @blur="handleBlur(parametrosLocal.tolGapAnchoMax)"
                    @change="recalcular"
                  />
                </div>

                <div style="font-size: 12px; color: #334155">
                  {{ labelGapDesarrollo }} <small>({{ unidadTexto }})</small>
                </div>
                <div>
                  <el-input-number
                    ref="inputRef"
                    v-model="parametrosLocal.tolGapDesarrolloMin"
                    :controls="false"
                    :formatter="formatter"
                    :parser="parser"
                    size="small"
                    class="w-100"
                    @focus="handleFocus"
                    @blur="handleBlur(parametrosLocal.tolGapDesarrolloMin)"
                    @change="recalcular"
                  />
                </div>
                <div>
                  <el-input-number
                    ref="inputRef"
                    v-model="parametrosLocal.tolGapDesarrolloMax"
                    :controls="false"
                    :formatter="formatter"
                    :parser="parser"
                    size="small"
                    class="w-100"
                    @focus="handleFocus"
                    @blur="handleBlur(parametrosLocal.tolGapDesarrolloMax)"
                    @change="recalcular"
                  />
                </div>
              </div>
            </el-popover>
          </div>
        </el-card>

        <div
          v-if="store.opcionActiva"
          class="viz-card"
        >
          <div class="viz-header">
            <span class="mini"
              >Máquina:
              <b>{{
                store.opcionActiva.nombreMaquina ||
                formatMedida(store.opcionActiva.visualizacion.anchoMaquina) + ' ' + unidadTexto
              }}</b></span
            >
            <span class="mini"
              >Impresión: <b>{{ formatMedida(store.opcionActiva.anchoImpresion) }}</b>
              {{ unidadTexto }}</span
            >
            <span class="mini"
              >Bocas:
              <b
                >{{ store.opcionActiva.bocasAncho }} × {{ store.opcionActiva.bocasDesarrollo }}</b
              ></span
            >
            <span class="mini">
              Med. A.:
              <b
                :style="{
                  color:
                    Math.abs(store.opcionActiva.medidaAnchoUsada - parametrosLocal.medidaAncho) >
                    0.01
                      ? '#d97706'
                      : 'inherit',
                }"
              >
                {{ formatDecimal(store.opcionActiva.medidaAnchoUsada) }}
              </b>
              {{ unidadTexto }}
            </span>
            <span class="mini">
              Med. D.:
              <b
                :style="{
                  color:
                    Math.abs(
                      store.opcionActiva.medidaDesarrolloUsada - parametrosLocal.medidaDesarrollo,
                    ) > 0.01
                      ? '#d97706'
                      : 'inherit',
                }"
              >
                {{ formatDecimal(store.opcionActiva.medidaDesarrolloUsada) }}
              </b>
              {{ unidadTexto }}
            </span>
            <span class="mini"
              >Gap A.: <b>{{ formatDecimal(store.opcionActiva.visualizacion.gapAncho) }}</b>
              {{ unidadTexto }}</span
            >
            <span class="mini"
              >Gap D.: <b>{{ formatDecimal(store.opcionActiva.visualizacion.gapDesarrollo) }}</b>
              {{ unidadTexto }}</span
            >
            <span class="mini"
              >Aprov.: <b>{{ store.opcionActiva.aprovechamientoPorcentaje.toFixed(1) }}%</b></span
            >
            <span
              v-if="false"
              class="mini"
              >Troquel: <b>{{ store.opcionActiva.codigoTroquelSugerido || '—' }}</b></span
            >
            <span class="mini"
              >Z: <b>{{ store.opcionActiva.engranaje || '—' }}</b></span
            >
          </div>

          <custom-imposicion
            :cavidadesAncho="store.opcionActiva.visualizacion.bocasAncho"
            :cavidadesDesarrollo="store.opcionActiva.visualizacion.bocasDesarrollo"
            :gapDesarrollo="store.opcionActiva.visualizacion.gapDesarrollo"
            :gapEje="store.opcionActiva.visualizacion.gapAncho"
            :medidaAlEje="store.opcionActiva.visualizacion.medidaAncho"
            :medidaAlDesarrollo="store.opcionActiva.visualizacion.medidaDesarrollo"
            :laterales="store.opcionActiva.visualizacion.margenLateral"
            :anchoImposicion="store.opcionActiva.visualizacion.anchoBobinaUsada"
            :largoImposicion="store.opcionActiva.visualizacion.desarrolloCilindro"
            :showLabels="true"
          />
        </div>
        <el-empty
          v-else
          description="Seleccione una opción de la tabla para previsualizar"
          :image-size="80"
          style="
            background: white;
            border: 1px solid #ebeef5;
            border-radius: 8px;
            margin-bottom: 15px;
          "
        />

        <div
          v-if="store.opcionActiva"
          class="kpi-grid"
        >
          <div class="kpi-box">
            <span>Selección</span>
            <b>{{ store.opcionActiva.descripcionMaterial }}</b>

            <div
              style="
                display: flex;
                flex-direction: column;
                margin-top: 8px;
                font-size: 0.85em;
                gap: 2px;
              "
            >
              <div style="font-weight: normal">
                <b>Ancho bobina:</b>
                {{
                  store.opcionActiva.anchoBobinaMadre !== null
                    ? formatDecimal(store.opcionActiva.anchoBobinaMadre) + ' mm'
                    : 'A medida'
                }}
              </div>
              <div style="font-weight: normal">
                <b>Familia:</b> {{ store.opcionActiva.familiaMaterial || '—' }}
              </div>
              <div style="font-weight: normal">
                <b>Tipo:</b> {{ store.opcionActiva.tipoMaterial || '—' }}
              </div>
            </div>
          </div>
          <div class="kpi-box">
            <span>Imposición</span>
            <b
              >{{ store.opcionActiva.bocasAncho }}×{{ store.opcionActiva.bocasDesarrollo }} =
              {{ store.opcionActiva.totalBocas }} / vuelta</b
            >
            <small>
              <template v-if="store.opcionActiva.nombreMaquina"
                >Máquina: <b>{{ store.opcionActiva.nombreMaquina }}</b> ·
              </template>
              Ancho imp.: {{ formatMedida(store.opcionActiva.anchoImpresion) }}{{ unidadTexto }} ·
              Desarrollo: {{ formatMedida(store.opcionActiva.cilindro) }}{{ unidadTexto }}
            </small>
          </div>
          <div
            v-if="false"
            class="kpi-box"
          >
            <span>Consumo</span>
            <b
              >{{ store.opcionActiva.metrosLinealesRequeridos.toFixed(1) }} m ·
              {{ store.opcionActiva.metrosCuadrados.toFixed(2) }} m²</b
            >
            <small>
              Ancho red.: {{ formatDecimal(store.opcionActiva.anchoRedondeado) }}{{ unidadTexto }}
              <template v-if="store.opcionActiva.anchoBobinaMadre">
                (bobina madre {{ formatDecimal(store.opcionActiva.anchoBobinaMadre)
                }}{{ unidadTexto }})
              </template>
            </small>
          </div>
          <div class="kpi-box">
            <span>Ranking</span>
            <b>{{ store.opcionActiva.aprovechamientoPorcentaje.toFixed(1) }}% apro.</b>
            <small
              >Score: {{ store.opcionActiva.score.toFixed(1) }} · Troquel:
              {{ store.opcionActiva.codigoTroquelSugerido || '—' }} ({{
                store.opcionActiva.matchTroquel
              }})</small
            >
          </div>
        </div>

        <div
          v-if="store.opcionActiva"
          class="warnlist"
        >
          <div
            v-if="store.opcionActiva.observaciones.includes('Redondeo supera ancho máquina')"
            class="warnitem"
          >
            <div class="dot dot-bad"></div>
            <div>
              <b>Ancho inválido post-redondeo</b>
              <span>Redondeo supera ancho máquina</span>
            </div>
          </div>

          <div
            v-if="store.opcionActiva.matchTroquel === 'exacto'"
            class="warnitem"
          >
            <div class="dot dot-ok"></div>
            <div>
              <b>Troquel exacto</b>
              <span>Existe troquel prefiltrado que matchea exactamente el formato.</span>
            </div>
          </div>

          <div
            v-if="store.opcionActiva.matchTroquel === 'tolerancia'"
            class="warnitem"
          >
            <div class="dot dot-warn"></div>
            <div>
              <b>Troquel por tolerancia</b>
              <span>Se sugiere troquel compatible por tolerancia dimensional.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {
  watch,
  ref,
  computed,
  reactive,
  onMounted,
  nextTick,
  shallowRef,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useImposicionStore } from '@/stores/imposicion/imposicion_store.js';
import { useConfiguracionesPorDefectoStore } from '@/views/configuraciones_por_defecto/stores/configuraciones_por_defecto_store.js';
import { useConfiguracionStore } from '@/stores/configuracion-general.js';
import CustomImposicion from '@/shared/components/custom_imposicion.vue';
import { useFormaStore } from '@/stores/forma/forma_store';
import { useSwageStore } from '@/stores/swage_store';
import { MaterialGenericoFiltroOptions } from '@/enum/material_generico_filtro.js';
import Sortable from 'sortablejs';
import IconRestore from '~icons/mdi/restore';
import { useLocaleNumberInput } from '@/shared/composables/useLocaleNumberInput.js';

const { inputRef, formatter, parser, handleFocus, handleBlur } = useLocaleNumberInput(null);

const props = defineProps({
  visible: Boolean,
  parametrosCotizacion: Object,
  materialHeredado: Object,
  maquinasDisponibles: { type: Array, default: () => [] },
  labelMedidaEje: { type: String, default: 'Medida ancho' },
  labelMedidaDesarrollo: { type: String, default: 'Medida desarrollo' },
  labelGapEje: { type: String, default: 'Gap ancho' },
  labelGapDesarrollo: { type: String, default: 'Gap desarrollo' },
  labelEtiquetasEje: { type: String, default: 'Repeticiones al ancho' },
  labelEtiquetasDesarrollo: { type: String, default: 'Repeticiones al desarrollo' },
  labelLaterales: { type: String, default: 'Laterales' },
});

const emit = defineEmits(['cerrar', 'aplicar']);
const store = useImposicionStore();
const configuracionesPorDefectoStore = useConfiguracionesPorDefectoStore();
const configuracionStore = useConfiguracionStore();
const formaStore = useFormaStore();
const swageStore = useSwageStore();

const TODAS_CODIGO = -1;
const maquinaSeleccionada = ref(TODAS_CODIGO);

const maquinaOpciones = computed(() => {
  const maquinas = (props.maquinasDisponibles || []).map((m) => ({
    Codigo: m.Codigo,
    Descripcion: m.Descripcion,
    AnchoMaximo: m.AnchoMaximo,
  }));
  return [{ Codigo: TODAS_CODIGO, Descripcion: 'TODAS' }, ...maquinas];
});

const maquinaSeleccionadaObj = computed(() => {
  if (maquinaSeleccionada.value === TODAS_CODIGO) return null;
  return (
    (props.maquinasDisponibles || []).find((m) => m.Codigo === maquinaSeleccionada.value) || null
  );
});

const anchoMaximoMaquinaActual = computed(() => {
  if (maquinaSeleccionada.value === TODAS_CODIGO) return null;
  return maquinaSeleccionadaObj.value?.AnchoMaximo || 0;
});

const mostrarAlertaAnchoCero = computed(() => {
  if (maquinaSeleccionada.value === TODAS_CODIGO) return false;
  const obj = maquinaSeleccionadaObj.value;
  return obj && (!obj.AnchoMaximo || obj.AnchoMaximo === 0);
});

const { formaList } = storeToRefs(formaStore);

const { categoriasDisponibles, familiasDisponibles, tiposDisponibles, isLoadingFiltros } =
  storeToRefs(store);

const familiaDescripcionTexto = ref('');
const filtros = reactive({ troquel: '', texto: '', cilindro: '' });
const parametrosLocal = reactive({
  tolMedidaAnchoMin: 0,
  tolMedidaAnchoMax: 0,
  tolMedidaDesarrolloMin: 0,
  tolMedidaDesarrolloMax: 0,
  tolGapAnchoMin: 0,
  tolGapAnchoMax: 0,
  tolGapDesarrolloMin: 0,
  tolGapDesarrolloMax: 0,
});
const overridesTolerancia = ref({});
const habilitarGapAncho = ref(false);
const habilitarGapDesarrollo = ref(false);
const habilitarEtiquetasEje = ref(false);
const habilitarEtiquetasDesarrollo = ref(false);
const ordenActualTexto = ref('score desc');
const unidadTexto = computed(() => parametrosLocal.unidadPreferencia || 'mm');
const isTableExpanded = ref(false);

const tableRef = ref(null);
const columnas = ref([]);

const tableKey = ref(0);
let sortableInstance = null;

const paginaActual = ref(1);
const filasPorPagina = ref(50);

const columnasPorDefecto = [
  { prop: 'nombreMaquina', label: 'Máquina', width: '110', sortable: 'custom' },
  {
    prop: 'descripcionMaterial',
    label: 'Material',
    minWidth: '160',
    tooltip: true,
    sortable: 'custom',
  },
  { prop: 'familiaMaterial', label: 'Familia', width: '90', sortable: 'custom' },
  {
    prop: 'precioMaterial',
    label: 'Precio ($/m²)',
    width: '95',
    align: 'right',
    sortable: 'custom',
  },
  {
    prop: 'medidaAnchoUsada',
    label: 'Medida A. ({u})',
    width: '110',
    align: 'right',
    sortable: 'custom',
  },
  {
    prop: 'medidaDesarrolloUsada',
    label: 'Medida D. ({u})',
    width: '110',
    align: 'right',
    sortable: 'custom',
  },
  { prop: 'bocasAncho', label: 'Rep. ancho', width: '105', align: 'center', sortable: 'custom' },
  { prop: 'bocasDesarrollo', label: 'Rep. des.', width: '95', align: 'center', sortable: 'custom' },
  { prop: 'totalBocas', label: 'Total', width: '70', align: 'center', sortable: 'custom' },
  {
    prop: 'visualizacion.gapAncho',
    label: 'Gap A.',
    width: '85',
    align: 'right',
    sortable: 'custom',
  },
  {
    prop: 'visualizacion.gapDesarrollo',
    label: 'Gap D.',
    width: '85',
    align: 'right',
    sortable: 'custom',
  },
  {
    prop: 'anchoImpresion',
    label: 'Ancho imp. ({u})',
    width: '130',
    align: 'right',
    sortable: 'custom',
  },
  {
    prop: 'anchoMinimo',
    label: 'Ancho mín. ({u})',
    width: '130',
    align: 'right',
    sortable: 'custom',
  },
  {
    prop: 'anchoRedondeado',
    label: 'Ancho red. ({u})',
    width: '135',
    align: 'right',
    sortable: 'custom',
  },
  {
    prop: 'anchoBobinaMadre',
    label: 'Bobina madre ({u})',
    width: '145',
    align: 'right',
    sortable: 'custom',
  },
  { prop: 'cilindro', label: 'Desarrollo', width: '150', align: 'right', sortable: 'custom' },
  { prop: 'engranaje', label: 'Z', width: '70', align: 'center', sortable: 'custom' },
  {
    prop: 'cantidadCilindros',
    label: 'Cant. Cilindros',
    width: '130',
    align: 'center',
    sortable: 'custom',
  },
  {
    prop: 'cantidadMagneticos',
    label: 'Cant. Magnéticos',
    width: '140',
    align: 'center',
    sortable: 'custom',
  },
  {
    prop: 'cantidadAlmasStamping',
    label: 'Cant. Almas Stamping',
    width: '160',
    align: 'center',
    sortable: 'custom',
  },
  {
    prop: 'cantidadCilindrosRelieveEnLinea',
    label: 'Cant. Cil. Relieve en línea',
    width: '185',
    align: 'center',
    sortable: 'custom',
  },
  {
    prop: 'metrosLinealesRequeridos',
    label: 'ML (m)',
    width: '85',
    align: 'right',
    sortable: 'custom',
  },
  { prop: 'metrosCuadrados', label: 'm²', width: '80', align: 'right', sortable: 'custom' },
  { prop: 'kg', label: 'Kg', width: '60', align: 'center', sortable: false },
  {
    prop: 'aprovechamientoPorcentaje',
    label: 'Aprovech.%',
    width: '105',
    align: 'center',
    sortable: 'custom',
  },
  { prop: 'score', label: 'Score', width: '80', align: 'center', sortable: 'custom' },
  { prop: 'observaciones', label: '⚠ Observaciones', width: '200', tooltip: true, sortable: false },
];

const cargarOrdenColumnas = () => {
  const ordenGuardado = localStorage.getItem('ordenColumnasImposicion');
  if (ordenGuardado) {
    const propsOrdenadas = JSON.parse(ordenGuardado);
    columnas.value = propsOrdenadas
      .map((prop) => columnasPorDefecto.find((col) => col.prop === prop))
      .filter(Boolean);

    columnasPorDefecto.forEach((col) => {
      if (!columnas.value.find((c) => c.prop === col.prop)) {
        columnas.value.push(col);
      }
    });
  } else {
    columnas.value = [...columnasPorDefecto];
  }
};

const inicializarDragAndDrop = () => {
  if (!tableRef.value) return;
  const el = tableRef.value.$el.querySelector('.el-table__header-wrapper tr');
  if (!el) return;

  if (sortableInstance) {
    sortableInstance.destroy();
  }

  sortableInstance = Sortable.create(el, {
    animation: 150,
    delay: 0,
    onEnd: (evt) => {
      const { oldIndex, newIndex } = evt;
      if (oldIndex === newIndex) return;

      const filaMovida = columnas.value.splice(oldIndex, 1)[0];
      columnas.value.splice(newIndex, 0, filaMovida);

      const nuevoOrden = columnas.value.map((col) => col.prop);
      localStorage.setItem('ordenColumnasImposicion', JSON.stringify(nuevoOrden));

      tableKey.value += 1;

      nextTick(() => {
        inicializarDragAndDrop();

        if (store.opcionActiva) {
          const rowToSelect = opcionesFiltradas.value.find((r) => r.id === store.opcionActiva.id);
          if (rowToSelect && tableRef.value) {
            tableRef.value.setCurrentRow(rowToSelect);
          }
        }
      });
    },
  });
};

const toggleTableExpand = () => {
  isTableExpanded.value = !isTableExpanded.value;
};

const handleToggleEtiquetasEje = (habilitado) => {
  if (!habilitado) {
    parametrosLocal.etiquetasEje = null;
  } else if (!parametrosLocal.etiquetasEje) {
    parametrosLocal.etiquetasEje = 1;
  }
  recalcular();
};

const handleToggleEtiquetasDesarrollo = (habilitado) => {
  if (!habilitado) {
    parametrosLocal.etiquetasDesarrollo = null;
  } else if (!parametrosLocal.etiquetasDesarrollo) {
    parametrosLocal.etiquetasDesarrollo = 1;
  }
  recalcular();
};

const formatMedida = (valor) => {
  if (valor === null) return '—';
  return unidadTexto.value === 'in' ? Number(valor).toFixed(4) : Math.round(valor).toString();
};

const formatDecimal = (valor) => {
  if (valor === null) return '—';
  return unidadTexto.value === 'in' ? Number(valor).toFixed(4) : Number(valor).toFixed(3);
};

const recalcular = () => {
  if (mostrarAlertaAnchoCero.value) return;

  const payloadParaBackend = { ...parametrosLocal };
  delete payloadParaBackend.codigoElementoTipoBase;
  delete payloadParaBackend.codigoMaquina;
  delete payloadParaBackend.maquinasDisponibles;

  if (maquinaSeleccionada.value === TODAS_CODIGO) {
    payloadParaBackend.codigoMaquinas = (props.maquinasDisponibles || []).map((m) => m.Codigo);
  } else {
    payloadParaBackend.codigoMaquinas = [maquinaSeleccionada.value];
  }
  payloadParaBackend.maquina = {
    anchoMaximo: anchoMaximoMaquinaActual.value !== null ? anchoMaximoMaquinaActual.value : 0,
  };

  store.calcularOpciones(payloadParaBackend);
};

const handleMaquinaChange = (codigo) => {
  const maq = props.maquinasDisponibles.find((m) => m.Codigo === codigo);
  console.log('Máquina seleccionada:', maq);
  recalcular();
};

const resetearFiltrosImposicion = () => {
  habilitarGapAncho.value = false;
  habilitarGapDesarrollo.value = false;
  habilitarEtiquetasEje.value = false;
  habilitarEtiquetasDesarrollo.value = false;

  parametrosLocal.gapAncho = null;
  parametrosLocal.gapDesarrollo = null;
  parametrosLocal.etiquetasEje = null;
  parametrosLocal.etiquetasDesarrollo = null;

  filtros.cilindro = '';
  parametrosLocal.criterioRedondeo = 'sin_definir';

  recalcular();
};

// Claves del ABM de Configuraciones por defecto para cada campo de tolerancia, con su
// respectivo getter del store (valor global) y el override cargado para este producto.
const TOLERANCIA_CLAVES = {
  tolMedidaAnchoMin: 'tolMedidaAnchoMin',
  tolMedidaAnchoMax: 'tolMedidaAnchoMax',
  tolMedidaDesarrolloMin: 'tolMedidaDesarrolloMin',
  tolMedidaDesarrolloMax: 'tolMedidaDesarrolloMax',
  tolGapAnchoMin: 'tolGapAnchoMin',
  tolGapAnchoMax: 'tolGapAnchoMax',
  tolGapDesarrolloMin: 'tolGapDesarrolloMin',
  tolGapDesarrolloMax: 'tolGapDesarrolloMax',
};

function aplicarDefaultsTolerancia() {
  for (const campo of Object.keys(TOLERANCIA_CLAVES)) {
    if (parametrosLocal[campo]) continue; // ya trae un valor propio de la operación

    const override = overridesTolerancia.value[campo];
    if (override !== undefined && override !== null) {
      parametrosLocal[campo] = override;
      continue;
    }

    const valorGlobal = configuracionesPorDefectoStore[TOLERANCIA_CLAVES[campo]];
    if (valorGlobal !== null && valorGlobal !== undefined) {
      parametrosLocal[campo] = valorGlobal;
    }
  }

  // Comportamiento histórico previo al ABM: si ni el override ni el valor global configuran
  // el Gap en Desarrollo, se conserva la distinción por tipo de producto que ya existía.
  if (!parametrosLocal.tolGapDesarrolloMin && !parametrosLocal.tolGapDesarrolloMax) {
    const esFlexible = parametrosLocal.elementoTipo === 'FLEXIBLE_FLEXO';
    parametrosLocal.tolGapDesarrolloMin = esFlexible ? 0 : 3;
    parametrosLocal.tolGapDesarrolloMax = esFlexible ? 0 : 6;
  }
}

const resetParametros = () => {
  Object.assign(parametrosLocal, JSON.parse(JSON.stringify(props.parametrosCotizacion)));

  const codigoMaqOriginal = props.parametrosCotizacion.codigoMaquina;

  if (
    codigoMaqOriginal &&
    (props.maquinasDisponibles || []).some((m) => m.Codigo === codigoMaqOriginal)
  ) {
    maquinaSeleccionada.value = codigoMaqOriginal;
  } else if (props.maquinasDisponibles && props.maquinasDisponibles.length === 1) {
    maquinaSeleccionada.value = props.maquinasDisponibles[0].Codigo;
  } else {
    maquinaSeleccionada.value = TODAS_CODIGO;
  }

  aplicarDefaultsTolerancia();
  if (parametrosLocal.criterioRedondeo === undefined)
    parametrosLocal.criterioRedondeo = 'sin_definir';
  if (parametrosLocal.filtroGenerico === undefined)
    parametrosLocal.filtroGenerico = configuracionStore.filtroGenericoMaterialDefecto;
  if (parametrosLocal.permitirRotacion === undefined) parametrosLocal.permitirRotacion = false;
  const traeEtiqEje = props.parametrosCotizacion.etiquetasEje > 1;
  const traeEtiqDes = props.parametrosCotizacion.etiquetasDesarrollo > 1;

  habilitarEtiquetasEje.value = traeEtiqEje;
  habilitarEtiquetasDesarrollo.value = traeEtiqDes;

  parametrosLocal.etiquetasEje = traeEtiqEje ? props.parametrosCotizacion.etiquetasEje : null;
  parametrosLocal.etiquetasDesarrollo = traeEtiqDes
    ? props.parametrosCotizacion.etiquetasDesarrollo
    : null;
  parametrosLocal.formaTroquel = props.parametrosCotizacion.formaTroquel || null;
  parametrosLocal.codigoSuajeTipo = 'ninguno';
  const traeGapAncho = props.parametrosCotizacion.gapAncho > 0;
  const traeGapDesarrollo = props.parametrosCotizacion.gapDesarrollo > 0;
  habilitarGapAncho.value = traeGapAncho;
  habilitarGapDesarrollo.value = traeGapDesarrollo;
  if (!habilitarGapAncho.value) parametrosLocal.gapAncho = null;
  if (!habilitarGapDesarrollo.value) parametrosLocal.gapDesarrollo = null;
  filtros.troquel = '';
  filtros.cilindro = '';
  filtros.texto = props.materialHeredado?.descripcionMaterial || '';

  familiaDescripcionTexto.value = props.materialHeredado?.descFamilia || '';

  recalcular();
};

const anchoMinimoCalculado = computed(() => {
  const ancho = Number(parametrosLocal.medidaAncho) || 0;
  const laterales = Number(parametrosLocal.laterales) || 0;

  const gap = habilitarGapAncho.value
    ? Number(parametrosLocal.gapAncho) || 0
    : Number(parametrosLocal.tolGapAnchoMin) || 0;

  const cantEje =
    Number(parametrosLocal.etiquetasEje) > 0 ? Number(parametrosLocal.etiquetasEje) : 1;
  return ancho * cantEje + gap * (cantEje - 1) + laterales * 2;
});

const CLAVE_INTERNA_A_CAMPO = {
  tol_medida_ancho_min: 'tolMedidaAnchoMin',
  tol_medida_ancho_max: 'tolMedidaAnchoMax',
  tol_medida_desarrollo_min: 'tolMedidaDesarrolloMin',
  tol_medida_desarrollo_max: 'tolMedidaDesarrolloMax',
  tol_gap_ancho_min: 'tolGapAnchoMin',
  tol_gap_ancho_max: 'tolGapAnchoMax',
  tol_gap_desarrollo_min: 'tolGapDesarrolloMin',
  tol_gap_desarrollo_max: 'tolGapDesarrolloMax',
};

async function cargarOverridesTolerancia(codigoElementoTipo) {
  overridesTolerancia.value = {};
  if (!codigoElementoTipo) return;

  try {
    const overrides =
      await configuracionesPorDefectoStore.findOverridesByElementoTipoHTTP(codigoElementoTipo);
    const mapa = {};
    for (const override of overrides) {
      const campo = CLAVE_INTERNA_A_CAMPO[override.ClaveInterna];
      if (!campo) continue;
      const numero = Number(override.Valor);
      if (!Number.isNaN(numero)) mapa[campo] = numero;
    }
    overridesTolerancia.value = mapa;
  } catch (error) {
    overridesTolerancia.value = {};
  }
}

const inicializarModal = async () => {
  if (props.parametrosCotizacion?.codigoElementoTipoBase) {
    await store.obtenerFiltrosDisponibles(props.parametrosCotizacion.codigoElementoTipoBase);
  }

  await cargarOverridesTolerancia(props.parametrosCotizacion?.codigoElementoTipoBase);

  resetParametros();

  if (parametrosLocal.codigoFamiliaMaterial && !familiaDescripcionTexto.value) {
    const familiaEncontrada = familiasDisponibles.value.find(
      (f) => f.Codigo === parametrosLocal.codigoFamiliaMaterial,
    );
    if (familiaEncontrada) {
      familiaDescripcionTexto.value = familiaEncontrada.Descripcion;
    }
  }
};

watch(
  () => props.visible,
  (esVisible) => {
    if (esVisible) {
      inicializarModal();
    }
  },
  { immediate: true },
);

const handleFamiliaSearch = (query, cb) => {
  let results = familiasDisponibles.value;
  if (query) {
    const q = query.toLowerCase();
    results = results.filter((f) => f.Descripcion?.toLowerCase().includes(q));
  }
  cb(results);
};

const handleFamiliaSelect = (itemSeleccionado) => {
  if (itemSeleccionado) {
    parametrosLocal.codigoFamiliaMaterial = itemSeleccionado.Codigo;
    familiaDescripcionTexto.value = itemSeleccionado.Descripcion;
    handleFamiliaChange();
  }
};

const handleFamiliaClear = () => {
  parametrosLocal.codigoFamiliaMaterial = null;
  familiaDescripcionTexto.value = '';
  handleFamiliaChange();
};

const handleCategoriaChange = () => {
  parametrosLocal.codigoFamiliaMaterial = null;
  familiaDescripcionTexto.value = '';
  parametrosLocal.codigoMaterialTipo = null;
  recalcular();
};

const handleFamiliaChange = () => {
  parametrosLocal.codigoMaterialTipo = null;
  recalcular();
};

const handleToggleGapAncho = (habilitado) => {
  if (!habilitado) {
    parametrosLocal.gapAncho = null;
  } else if (parametrosLocal.gapAncho === null) {
    parametrosLocal.gapAncho = 0;
  }
  recalcular();
};

const handleToggleGapDesarrollo = (habilitado) => {
  if (!habilitado) {
    parametrosLocal.gapDesarrollo = null;
  } else if (parametrosLocal.gapDesarrollo === null) {
    parametrosLocal.gapDesarrollo = 0;
  }
  recalcular();
};

const tiposFiltrados = computed(() => {
  if (!parametrosLocal.codigoCategoriaMaterial) return tiposDisponibles.value;
  return tiposDisponibles.value.filter(
    (t) => t.CodigoMaterialCategoria === parametrosLocal.codigoCategoriaMaterial,
  );
});

const toggleRotar = () => {
  parametrosLocal.permitirRotacion = !parametrosLocal.permitirRotacion;
  recalcular();
};

const cilindrosDisponibles = computed(() =>
  [...new Set(store.opciones.map((o) => o.cilindro))].sort((a, b) => a - b),
);

const estadoPostRedondeo = computed(() => {
  if (!store.opciones.length) return '-';
  return store.opciones.some((o) => o.observaciones.includes('supera'))
    ? 'check (hay errores)'
    : 'ok';
});

const tableSort = reactive({ prop: 'score', order: 'descending' });

const handleSortChange = ({ prop, order }) => {
  if (!order) {
    tableSort.prop = 'score';
    tableSort.order = 'descending';
  } else {
    tableSort.prop = prop;
    tableSort.order = order;
  }
  ordenActualTexto.value = `${tableSort.prop} ${tableSort.order === 'descending' ? 'desc' : 'asc'}`;
};

const opcionesFiltradas = shallowRef([]);

const recalcularFiltrado = () => {
  let list = [...store.opciones];

  if (filtros.troquel) list = list.filter((o) => o.matchTroquel === filtros.troquel);
  if (filtros.cilindro) list = list.filter((o) => o.cilindro === filtros.cilindro);
  if (filtros.texto) {
    const q = filtros.texto.toLowerCase();
    list = list.filter(
      (o) =>
        o.descripcionMaterial.toLowerCase().includes(q) || String(o.anchoRedondeado).includes(q),
    );
  }

  list.sort((a, b) => {
    const getNestedValue = (obj, path) => {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    let propReal = tableSort.prop;
    if (propReal === 'anchoMinimo') propReal = 'anchoImpresion';

    let valA = getNestedValue(a, propReal);
    let valB = getNestedValue(b, propReal);

    if (valA === null) valA = 0;
    if (valB === null) valB = 0;

    if (typeof valA === 'string') {
      return tableSort.order === 'ascending' ? valA.localeCompare(valB) : valB.localeCompare(valA);
    }
    return tableSort.order === 'ascending' ? valA - valB : valB - valA;
  });

  opcionesFiltradas.value = list;
};

watch(
  () => [
    store.opciones,
    filtros.troquel,
    filtros.cilindro,
    filtros.texto,
    tableSort.prop,
    tableSort.order,
  ],
  recalcularFiltrado,
  { immediate: true, deep: true },
);

watch(
  () => [filtros.troquel, filtros.cilindro, filtros.texto],
  () => {
    paginaActual.value = 1;
  },
);

watch(
  () => store.opciones,
  () => {
    paginaActual.value = 1;
  },
);

const opcionesPaginadas = computed(() => {
  const inicio = (paginaActual.value - 1) * filasPorPagina.value;
  return opcionesFiltradas.value.slice(inicio, inicio + filasPorPagina.value);
});

watch(paginaActual, () => {
  nextTick(() => {
    if (store.opcionActiva && tableRef.value) {
      const rowToSelect = opcionesPaginadas.value.find((r) => r.id === store.opcionActiva.id);
      if (rowToSelect) {
        tableRef.value.setCurrentRow(rowToSelect);
      }
    }
  });
});

const handleFilaSeleccionada = (fila) => {
  if (fila) store.seleccionarOpcion(fila.id);
};

const cerrar = () => emit('cerrar');
const confirmar = () => {
  if (store.opcionActiva) {
    const maquinaGanadora =
      (props.maquinasDisponibles || []).find(
        (m) => m.Codigo === store.opcionActiva.codigoMaquina,
      ) || null;
    emit('aplicar', {
      opcion: store.opcionActiva,
      parametrosAjustados: parametrosLocal,
      maquinaGanadora,
    });
    cerrar();
  }
};

onMounted(async () => {
  if (swageStore.claseSuaje.length === 0) {
    await swageStore.findAllClaseSuajeHTTP();
  }
  cargarOrdenColumnas();
  nextTick(() => {
    inicializarDragAndDrop();
  });
});
</script>

<style scoped>
.imposicion-dialog :deep(.el-dialog__header) {
  display: none;
}
.imposicion-dialog :deep(.el-dialog__body) {
  padding: 0;
  background: #f8fafc;
  color: #334155;
}
.custom-header {
  padding: 12px 20px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.custom-header .title b {
  font-size: 15px;
  color: #0f172a;
  display: block;
}
.custom-header .title span {
  font-size: 12px;
  color: #64748b;
}
.top-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}
.pill-info {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  color: #334155;
}
.pill-info .muted {
  color: #64748b;
}

.layout-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
  gap: 16px;
  padding: 16px 20px;
  height: calc(100vh - 75px);
  overflow-y: auto;
}
.layout-grid.is-expanded {
  grid-template-columns: minmax(0, 1fr);
}
.left-col,
.right-col {
  min-width: 0;
  max-width: 100%;
}
.layout-grid.is-expanded .left-col {
  min-height: 60vh;
}
@media (max-width: 1200px) {
  .layout-grid {
    grid-template-columns: 1fr;
    height: auto;
  }
}

.left-col,
.right-col {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.full-h-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
}
.full-h-card :deep(.el-card__body) {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.card-title-row .subtitle {
  color: #64748b;
  font-size: 12px;
  margin-top: 2px;
}
.filters-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}
.filter-field label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 4px;
}
.state-row {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}
.table-wrapper {
  flex: 1;
  min-height: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.custom-table :deep(th.el-table__cell) {
  background-color: #f8fafc;
  color: #475569;
  font-size: 11px;
}
.params-card {
  border-radius: 12px;
}
.params-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}
.param-item label {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #475569;
  font-weight: 600;
  margin-bottom: 4px;
}
.param-item small {
  color: #94a3b8;
  font-weight: normal;
}
.w-100 {
  width: 100%;
}

.toggle-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
}
.toggle-row .txt b {
  font-size: 13px;
  color: #334155;
  display: block;
}
.toggle-row .txt span {
  font-size: 11px;
  color: #64748b;
}

.viz-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  height: 250px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-bottom: 15px;
}
.viz-header {
  position: absolute;
  top: 12px;
  left: 12px;
  right: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  z-index: 10;
}
.mini {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  color: #475569;
  backdrop-filter: blur(4px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.kpi-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 15px;
}
.kpi-box {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}
.kpi-box span {
  font-size: 12px;
  color: #0f172a;
  font-weight: bold;
}
.kpi-box b {
  font-size: 14px;
  color: #334155;
  margin: 6px 0 4px;
  font-family: monospace;
}
.kpi-box small {
  font-size: 11px;
  color: #64748b;
  line-height: 1.3;
}

.warnlist {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.warnitem {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 12px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 4px;
  flex: 0 0 auto;
}
.dot-info {
  background: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}
.dot-warn {
  background: #f59e0b;
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.15);
}
.dot-bad {
  background: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.15);
}
.dot-ok {
  background: #10b981;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.15);
}
.warnitem b {
  font-size: 12px;
  color: #334155;
  display: block;
}
.warnitem span {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
  display: block;
}

.muted {
  color: #94a3b8;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  padding: 8px 0 0;
}

.table-wrapper :deep(.el-table__body tr.current-row > td) {
  background-color: #dbeafe !important;
  color: #133458;
}

.table-wrapper :deep(.el-table__body tr.current-row:hover > td) {
  background-color: #bfdbfe !important;
}
</style>
